// extracted by mini-css-extract-plugin
export default {"reportContainer":"LabReport_reportContainer__vzqp6","heading":"LabReport_heading__gnEZg","description":"LabReport_description__SVKdW","submitButton":"LabReport_submitButton__YT8aK"};